var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inf-pack"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('流程图')))]),_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":`data:image/png;base64,${_vm.imgUrl}`}})]),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('处理记录')))]),_c('rcTable',{ref:"rcTable",attrs:{"tableAttr":_vm.tableAttr}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }